import React from "react";

export default function MainLoader({ message = "Loading" }) {
  return (
    <div className="fixed inset-0 z-[500] flex min-h-screen items-center justify-center bg-white dark:bg-slate-950" role="status" aria-live="polite">
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="h-10 w-10 animate-spin rounded-full border-[3px] border-slate-200 border-t-customRed dark:border-slate-700 dark:border-t-customRed" />
        <p className="text-xs font-bold tracking-wide text-slate-500 dark:text-slate-300">{message}...</p>
      </div>
    </div>
  );
}
